export default __webpack_public_path__ + "static/media/006.8ce42fcf.jpg";